import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import './FormCheckbox.scss';

const FormCheckbox = ({
  name,
  children = '',
  initialValue,
  disabled = false,
  required = false,
  value // Removed default = true to enable "Boolean Mode"
}) => {
  const inputId = `form-checkbox--${name}`;

  const captionClasses = classNames('form-checkbox__caption', {
    'form-checkbox__caption--disabled': disabled
  });

  return (
    <label htmlFor={inputId} className="form-checkbox">
      <Field
        id={inputId}
        name={name}
        component="input"
        type="checkbox"
        className="form-checkbox__styled"
        initialValue={initialValue}
        disabled={disabled}
        required={required}
        // If value is undefined, Final Form toggles between true/false
        // If value is defined, it toggles that specific value in an array/string
        value={value}
      />
      <span className={captionClasses}>{children}</span>
    </label>
  );
};

FormCheckbox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  initialValue: PropTypes.bool,
  value: PropTypes.any
};

export default FormCheckbox;
